import React, { useState } from 'react';
import { FaHardHat, FaPlay, FaRoad } from 'react-icons/fa';
import ModalVideo from 'react-modal-video';
import '../../../node_modules/react-modal-video/scss/modal-video.scss';
import aboutImg from '../../assets/img/about_us.jpg';
import btnImg from '../../assets/img/skill_bg.jpg';
import IconBox from './IconBox';

function AboutFeatured() {
    const [isOpen, setOpen] = useState(false);
    return (
        <>
            <ModalVideo
                channel="youtube"
                autoplay
                isOpen={isOpen}
                videoId="EZ9DrY43wtw"
                onClose={() => setOpen(false)}
            />
            <section className="about-featured-wrapper section-padding">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-6 col-lg-5 col-12">
                            <div
                                className="about-promo bg-cover"
                                style={{ backgroundImage: `url(${aboutImg})` }}
                            >
                                <div
                                    className="skill-popup-video d-flex justify-content-center align-items-center bg-cover"
                                    style={{ backgroundImage: `url(${btnImg})` }}
                                >
                                    <div className="video-play-btn">
                                        <button
                                            type="button"
                                            className="modal-btn"
                                            onClick={() => setOpen(true)}
                                        >
                                            <FaPlay />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-6 col-lg-7 col-12 mt-5 mt-lg-0">
                            <div className="block-contents ml-lg-5">
                                <span>Cine suntem?</span>
                                <h1>Work Express - Partenerul Tău de Încredere</h1>
                                <h4>
                                    Înființată în 2017, Work Express s-a impus rapid ca un partener de încredere și o forță inovatoare pe piață. Echipa noastră, formată din profesioniști dedicați, este focalizată pe atingerea excelenței în tot ceea ce facem.
                                </h4>
                                <p>
                                    Ne mândrim cu o cultură organizațională bazată pe integritate, colaborare și inovație continuă. Creșterea noastră constantă și feedback-ul pozitiv de la clienți reflectă angajamentul nostru de a depăși așteptările și de a contribui activ la succesul acestora.
                                </p>
                            </div>

                            <div className="icon-boxs ml-lg-5">
                                <IconBox
                                    icon={<FaHardHat />}
                                    heading="100% Calitate"
                                    text="Ne angajăm să oferim servicii de cea mai înaltă calitate, utilizând materiale premium și tehnici moderne de construcție"
                                />
                                <IconBox
                                    icon={<FaRoad />}
                                    heading="Muncitori Profesioniști Calificați"
                                    text="Echipa noastră este formată din meșteri calificați cu experiență vastă în domeniul construcțiilor și renovărilor"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default AboutFeatured;
